import dynamic from "next/dynamic";

import { BaseEntry, TargetSite } from "@/types";

export const COMPONENTS: Record<string, any> = {
  socialMediaPresence: dynamic(() => import("./SocialMediaPresence/SocialMediaPresence")),
  heroEventLaunchCard: dynamic(() => import("./HeroCarousel/EventLaunchCard")),
  homepageHero: dynamic(() => import("./HeroCarousel/HomePageHeroCarousel")),
  heroFirstCard: dynamic(() => import("./HeroCarousel/HeroFirstCard")),
  heroFirstCard_Corporate: dynamic(() => import("./HeroCarousel/HeroFirstCard_Corporate")),
  heroProjectCommunityCard: dynamic(() => import("./HeroCarousel/HeroProjectCommunityCard")),
  verticalCardSlideShow: dynamic(() => import("./VerticalCardSlideShow/VerticalCardSlideShow")),
  editorial1Col: dynamic(() => import("./UnitGallery/UnitEditorial1Col")),
  textBaseline: dynamic(() => import("./TextBaseline/TextBaseline")),
  editorial1Col_Corporate: dynamic(() => import("./UnitGallery_Corporate/UnitEditorial1Col")),
  textBaseline_Corporate: dynamic(() => import("./TextBaseline_Corporate/TextBaseline")),
  downloadMedia_Corporate: dynamic(() => import("./TextBaseline_Corporate/DownloadMedia")),
  dataGrid: dynamic(() => import("./TextBaseline/DataGrid")),
  downloadMedia: dynamic(() => import("./TextBaseline/DownloadMedia")),
  mediaBasic: dynamic(() => import("./Media/Media")),
  editorial2Col: dynamic(() => import("./Editorial2Col/Editorial2Col")),
  editorialModuleImage: dynamic(() => import("./Editorial2Col/EditorialModuleImage")),
  editorialModuleText: dynamic(() => import("./Editorial2Col/EditorialModuleText")),
  editorialModuleText2: dynamic(() => import("./Editorial2Col/EditorialModuleText2")),
  editorialModuleHighlights: dynamic(() => import("./Editorial2Col/EditorialModuleHighlights")),
  editorialModuleListIcon: dynamic(() => import("./Editorial2Col/EditorialModuleListIcon")),
  autoScrollTiles: dynamic(() => import("./AutoScrollTiles/AutoScrollTiles")),
  history: dynamic(() => import("./HistoryCarousel/HistoryCarousel")),
  tabbedCarousel: dynamic(() => import("./TabGallery/TabGallery")),
  editorialFeatureList: dynamic(() => import("./FeatureList/FeatureList")),
  editorialFeatureList_Corporate: dynamic(() => import("./FeatureList_Corporate/FeatureList")),
  mediaBannerHighlight: dynamic(() => import("./MediaBannerHighlight/MediaBannerHighlight"), { ssr: false }),
  mediaBannerHighlight_Corporate: dynamic(() => import("./MediaBannerHighlight_Corporate/MediaBannerHighlight"), { ssr: false }),
  galleryCardCarousel: dynamic(() => import("./CardsGalleriesCarousel/CardsGalleriesCarousel"), { ssr: false }),
  cityLocation: dynamic(() => import("./CityLocation/CityLocation")),
  introInventory: dynamic(() => import("./InventoryLpIntro/InventoryLpIntro")),
  carouselTag: dynamic(() => import("./StorytellingCarousel/StorytellingCarousel"), { ssr: false }),
  editorialCarousel: dynamic(() => import("./AutogeneratedCarousel/AutogeneratedCarousel")),
  videoCarousel: dynamic(() => import("./AutogeneratedCarousel/AutogeneratedCarousel"), { ssr: false }),
  editorialVideoListing: dynamic(() => import("./VideoListing/VideoListing"), { ssr: false }),
  articleCarousel: dynamic(() => import("./AutogeneratedCarousel/ArticleCarouselWrapper"), { ssr: false }),
  highlightDualColumn: dynamic(() => import("./MediaHighlightDualColumn/MediaHighlightDualColumn")),
  editorial3ColumnCardList: dynamic(() => import("./EditorialThreeColumns/EditorialThreeColumns")),
  editorial3ColumnCardList_Corporate: dynamic(() => import("./EditorialThreeColumns_Corporate/EditorialThreeColumns")),
  editorialStickyBar: dynamic(() => import("./StickyBar/StickyBarEditorial")),
  articleList: dynamic(() => import("./ArticleListing/ArticleListingWrapper"), { ssr: false }),
  faqBox: dynamic(() => import("./FAQ/FAQ")),
  editorialInventory: dynamic(() => import("./EditorialInventory/EditorialInventory")),
  tileCarousel: dynamic(() => import("./TileCarousel/TileCarousel")),
  hubTemplateHero: dynamic(() => import("./HubTemplateHero/HubTemplateHero")),
  dHubIntro: dynamic(() => import("./DHubIntro/DHubIntroWrapper"), { ssr: false }),
  tabsComponent: dynamic(() => import("./TabNavigation/TabNavigation")),
  pageIntro: dynamic(() => import("./PageIntro/PageIntro")),
  heroBannerOos: dynamic(() => import("./OOSComponents/HeroBanner/HeroBanner")),
  buildingDocumentPageSection: dynamic(() => import("./OOSComponents/DocumentListing/DocumentListing")),
  singleColumnRichText: dynamic(() => import("./OOSComponents/SingleColumnRichText/SingleColumnRichText")),
  bentoList: dynamic(() => import("./BentoList/BentoList")),
  bentoList_Corporate: dynamic(() => import("./BentoList_Corporate/BentoList")),
  editorialTemplateHero: dynamic(() => import("./EditorialTemplateHero/EditorialTemplateHero")),
  breadcrumb: dynamic(() => import("./Breadcrumb/Breadcrumb")),
  editorial2Col_Corporate: dynamic(() => import("./EditorialDualColumn/EditorialDualColumn")),
  autogeneratedCarousel: dynamic(() => import("./AutogeneratedCarousel/AutogeneratedCarouselWrapper")),
  segmentedControl: dynamic(() => import("./SegmentedControl/SegmentedControl")),
  guidedToolLauncher: dynamic(() => import("./GuidedToolLauncher/GuidedToolLauncher")),
  contactServiced: dynamic(() => import("./ContactServices/ContactServices")),
  officeAddresses: dynamic(() => import("./OfficeAddress/OfficeAddress")),
  contactForm: dynamic(() => import("./ContactForm/ContactFormComponent")),
  documentCategoriesList: dynamic(() => import("./OOSComponents/DocumentCategories/DocumentCategories")),
  map: dynamic(() => import("./Map_Corporate/MapWrapper"), { ssr: false }),
  editorial1ColPropertyType3Button: dynamic(() => import("./TextBaseline/PropertyType3Buttons")),
  mortgageCalculator: dynamic(() => import("./MortgageCalculator/MortgageCalculatorForm"), { ssr: false }),
  anchor: dynamic(() => import("./UnitAnchors/UnitAnchors")),
  mcpEmptyDiv: dynamic(() => import("./EmptyDivMcp/EmptyDivMcp"), { ssr: false }),
};

interface Props {
  components: BaseEntry[];
  target?: TargetSite;
  [key: string]: any;
  indexKey?: number;
  isEditorialPage?: boolean;
}

export default function DynamicImport({ components, target, indexKey, isEditorialPage, ...rest }: Props) {
  return components?.map((component) => {
    let corporateSuffix = "";
    if (target === TargetSite.corporate) {
      corporateSuffix = "_" + target;
    }
    const Component = COMPONENTS[component?.type + corporateSuffix] || COMPONENTS[component?.type];
    if (Component) {
      // known bug with devtools https://github.com/vercel/next.js/issues/46566
      // Component.displayName = `${component.type}`;
      return (
        <Component
          key={component.id}
          indexKey={indexKey}
          firstComponent={isEditorialPage && component === components[0]}
          entry={component}
          {...rest}
        />
      );
    } else {
      return (
        <div key={component.id} className="flex flex-col gap-s justify-center h-full py-[80px] px-l items-stretch">
          <pre className="max-w-full overflow-auto bg-gray-7 text-black">{JSON.stringify(component, null, 2)}</pre>
        </div>
      );
    }
  });
}
